import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { getAgentRetailer } from "../../../services/agent.service";

export default function AgentRetailerDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [agentRetailer, setAgentRetailer] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const retailerID = params.get("id");
  // console.log("retailerID", retailerID);

  const fetchAgentRetailer = async () => {
    try {
      const res = await getAgentRetailer(token, retailerID);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);
        setAgentRetailer(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch agent details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main agent:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the agent. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (retailerID) {
      fetchAgentRetailer();
    }
  }, [retailerID]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Agent-Retailer Details</h4>
                <Link to="/agent/agent-retailer">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Agent Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Agent Name</h5>
                    <p>
                      {agentRetailer?.added_by
                        ? agentRetailer?.added_by.name
                        : "-"}
                    </p>
                  </div>
                  {/* Retailer Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Retailer Name</h5>
                    <p>{agentRetailer?.retailer_name || "N/A"}</p>
                  </div>
                  {/* shop Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Shop Name</h5>
                    <p>{agentRetailer?.shop_name || "N/A"}</p>
                  </div>

                  {/* email */}
                  <div className="col-sm-6 mb-4">
                    <h5>Email</h5>
                    <p>{agentRetailer?.email || "N/A"}</p>
                  </div>

                  {/* contact */}
                  <div className="col-sm-6 mb-4">
                    <h5>Mobile Number</h5>
                    <p>{agentRetailer?.mobile || "N/A"}</p>
                  </div>

                  {/* PAN_number */}
                  <div className="col-sm-6 mb-4">
                    <h5>PAN Number</h5>
                    <p>{agentRetailer?.pan_number || "N/A"}</p>
                  </div>

                  {/* GST_number */}
                  <div className="col-sm-6 mb-4">
                    <h5>GST Number</h5>
                    <p>{agentRetailer?.gst_number || "N/A"}</p>
                  </div>

                  <div className="col-sm-6 mb-4">
                    <h5>Address</h5>
                    <p>{agentRetailer?.address || "N/A"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
